import { initSwiper } from '@resources/js/components/initSwiper.js'
import inViewport from '@resources/js/helpers/inViewport'

//swiper logic
const swiperContainerElement = document.querySelector('.js-slider-container')

if (swiperContainerElement) {
	inViewport(swiperContainerElement, () => {
		const swiperElement = swiperContainerElement.querySelector('.js-slider')

		const swiperConfig = {
			loop: false,
			spaceBetween: '32',
			breakpoints: {
				425: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: 4,
				},
			},
			navigation: {
				prevEl: swiperContainerElement.querySelector('.js-slider-prev-btn'),
				nextEl: swiperContainerElement.querySelector('.js-slider-next-btn'),
			},
		}

		initSwiper(swiperElement, swiperConfig)
	})
}
